<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.cart')" />
      <div>
        <CartSelectAll :value="selectAllCart" @remove="removeSelected" @input="selectAll(!selectAllCart)" />
        <div v-if="loading" class="text-center" style="margin-top: 20%">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
          <div v-if="shoppingCart.length">
            <CartItem v-for="item in shoppingCart" :item="item" :key="item.id" v-model="itemsForCheckout" @remove="remove" @error="cartError" @refetch="refetch" />
          </div>
          <div v-else class="blank-message text-h6 font-weight-medium grey--text text-center">{{ $t('label.emptyCart') }}</div>
        </div>
      </div>
    </LayoutContent>
    <v-expand-transition>
      <bottom-bar backgroundColor="white" v-if="orderSummary.total">
        <v-container class="py-3 d-flex align-center">
          <div class="font-weight-bold text-subtitle-2 primary--text text--darken-1" style="width: 40%">
            <v-row no-gutters>
              <v-col>{{ $t('label.merchandiseTotal') }}:</v-col>
              <v-col>{{ orderSummary.currency }} {{ formatAmount(orderSummary.subtotal) }}</v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>{{ $t('label.tax') }}{{ orderSummary.tax_rate ? `(${orderSummary.tax_rate})` : '' }}:</v-col>
              <v-col>{{ orderSummary.subtotal_with_tax > orderSummary.subtotal ? orderSummary.currency + formatAmount(orderSummary.tax_amount) : '-' }}</v-col>
            </v-row>
          </div>
          <v-btn color="primary" class="ml-10 px-10 rounded-pill green-gradient-right text-capitalize ml-auto" @click="checkout">
            {{ $t('label.checkOut') }}
          </v-btn>
        </v-container>
      </bottom-bar>
    </v-expand-transition>
    <app-dialog v-model="showErrorDialog" title="" maxWidth="550" @click:outside="showErrorDialog = false">
      <div class="d-flex flex-column pt-16 px-5 rounded-lg" min-height="50vh">
        <div class="my-auto d-flex flex-column align-center">
          <p class="text-center font-weight-medium text-subtitle-1 px-4">{{ cartErrorMessage }}</p>
        </div>
        <div class="d-flex flex-column align-stretch mt-10">
          <app-button invert gradient :label="$t('button.okay')" class="py-5 mb-12" @click="showErrorDialog = false" />
        </div>
      </div>
    </app-dialog>
    <!-- <v-dialog content-class="elevation-0" v-model="imageOverlay" max-width="500">
      <ProductImagePreview @input="imageOverlay = false" :imageSrc="selectedImage" />
    </v-dialog> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { localeHelper, uiHelper } from '@/utils'

import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import CartItem from '@/components/checkout/CartItem.vue'
import CartSelectAll from '@/components/checkout/CartSelectAll.vue'
import ProductImagePreview from '@/components/product/ProductImagePreview.vue'
import ProductMixin from '@/mixins/product.mixin.js'

export default {
  name: 'cart',
  components: {
    LayoutContent,
    SectionTitle,
    CartItem,
    CartSelectAll
    // ProductImagePreview
  },
  mixins: [ProductMixin],
  data() {
    return {
      imageOverlay: false,
      showErrorDialog: false,
      cartErrorMessage: '',
      loading: false
    }
  },
  computed: {
    ...mapState('order', ['shoppingCart', 'itemsForCheckout', 'orderSummary']),
    selectAllCart: {
      get() {
        return this.shoppingCart.length == this.itemsForCheckout.length && this.itemsForCheckout.length
      },
      set() {}
    }
  },
  mounted() {
    this.loading = true
    this.getCartItem().finally(() => (this.loading = false))
  },
  methods: {
    ...mapActions('order', ['getCartItem']),
    async selectAll(checked) {
      await this.getCartItem()
      const selectAllItems = this.shoppingCart.map((item) => {
        if ((item.subtract_stock && item.cart_quantity > item.quantity) || (item.limit_per_order && item.cart_quantity > item.limit_per_order)) {
          const quantity = item.quantity > item.limit_per_order ? item.limit_per_order : item.quantity
          this.cartError(localeHelper.getMessage('message.cartMaxQuantityPerOrder', { product: item.product_name, quantity }), item.product_id)
          this.selectAllCart = false
          return
        }
        let cartItem = item
        cartItem.is_checked = checked
        return cartItem
      })

      this.selectAllCart = true
      if (!this.showErrorDialog) {
        this.editCartItem(selectAllItems)
      }
    },
    removeSelected() {
      let productArr = []
      let productVolumeArr = []
      this.itemsForCheckout.map((item) => {
        if (item.volume_variation === 0) productArr.push(item.product_id)
        else productVolumeArr.push(item.product_volume_variation_id)
      })
      let body = { product_id: { product_id: productArr }, product_volume_variation_id: { product_volume_variation_id: productVolumeArr } }
      this.remove(body)
    },
    remove(items) {
      this.deleteCartItems(items)
    },
    formatAmount(amount) {
      return uiHelper.priceFormatter(amount)
    },
    async checkout() {
      await this.getCartItem()
      const invalidItems = this.itemsForCheckout.filter((item) => {
        if ((item.subtract_stock && item.cart_quantity > item.quantity) || (item.limit_per_order && item.cart_quantity > item.limit_per_order)) {
          return item
        }
      })
      if (invalidItems.length > 0) {
        this.cartError(localeHelper.getMessage('message.cartInfoUpdated'))
        return
      }
      this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_CHECK_OUT })
    },
    cartError(message) {
      this.showErrorDialog = true
      this.cartErrorMessage = message
    },
    refetch() {
      this.loading = true
      this.getCartItem().finally(() => (this.loading = false))
    }
  }
}
</script>
<style lang="scss" scoped>
.blank-message {
  margin: 150px;
}
</style>
